<template>
  <v-container class="con_mpw">
    <div id="verify">
      <v-row no-gutters class="verify_box justify-center pt-10 pb-10">
        <!-- success -->
        <span class="icon verify"></span>
        <div class="file_inP_dorp_txtBox mb-10">
          <span><h3>계약 정보</h3> </span><br />
          계약 번호 : <span style="font-weight:700;">{{ ctrnum }}</span
          ><br /><br />
          <div v-if="resultCode === '2000'">
            요청자 : <span style="font-weight:700;">{{ senderInfo }} </span
            ><br /><br />
            수신자 : <span style="font-weight:700;">{{ reciverInfo }} </span
            ><span style="color:#f38bc7;font-weight:700;">{{ reciverCnt }}</span
            ><br /><br />
            상태 :
            <span style="font-weight:700;color:#40bfda;">{{
              ctrStatusInfo
            }}</span
            ><br /><br />
            <span
              >글로싸인엔터프라이즈에서 발행한
              <strong style="color:#40bfda;">신뢰할 수 있는 계약서</strong
              >입니다.</span
            ><br /><br />
            <span>현재 계약서 상태는</span>
            <span style="color:#40bfda;font-weight:700;">{{
              ctrStatusInfo
            }}</span>
            <span style="font-weight:700;">입니다.</span>
          </div>
        </div>
      </v-row>
      <s-confirm ref="confirm"></s-confirm>
      <s-loading ref="loading"></s-loading>
    </div>
  </v-container>
</template>
<script>
import { scanContract } from "@/api/contract/verifyContract";

export default {
  name: "scanContractNum",
  data() {
    return {
      isLogin: false,
      orgname: "",
      username: "",
      ctrnum: "",
      reciverInfo: "",
      senderInfo: "",
      ctrStatusInfo: "",
      verifyMsg: "",
      reciverCnt: "",
      resultCode: ""
    };
  },
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  methods: {
    checkNull(str) {
      if (typeof str == "undefined" || str == null || str == "") {
        return true;
      } else {
        return false;
      }
    },

    convertStr(str) {
      var nameEndCount = str.indexOf("(");
      var emailEndCount = str.indexOf(")");
      var name = this.nameMasking(str.substring(0, nameEndCount));
      var email = this.emailMasking(
        str.substring(nameEndCount + 1, emailEndCount)
      );
      var etc = str.substring(emailEndCount + 1);
      var result = name + "(" + email + ")" + " " + etc;

      console.log(result);
      return result;
    },

    nameMasking(str) {
      let originStr = str;
      let maskingStr;
      let strLength;
      if (this.checkNull(originStr) == true) {
        return originStr;
      }
      strLength = originStr.length;
      if (strLength < 3) {
        maskingStr = originStr.replace(/(?<=.{1})./gi, "*");
      } else {
        maskingStr = originStr.replace(/(?<=.{2})./gi, "*");
      }
      return maskingStr;
    },

    emailMasking(str) {
      str = str.split("");
      let finalArr = [];
      let len = str.indexOf("@");
      str.forEach((item, pos) => {
        pos >= 1 && pos <= len - 2
          ? finalArr.push("*")
          : finalArr.push(str[pos]);
      });

      return finalArr.join("");
    },

    scanContract() {
      this.reciverInfo = "";
      this.senderInfo = "";
      this.ctrStatusInfo = "";
      this.verifyMsg = "";
      this.reciverCnt = "";
      this.$refs.loading.start("계약정보 검증 중입니다.");

      scanContract(this.ctrnum)
        .then(response => {
          if (response.rdata.scancode.toString() === "2000") {
            this.resultCode = response.rdata.scancode;
            this.reciverInfo = this.convertStr(response.rdata.receiverName);
            if (response.rdata.receiverBrokerAdr.length > 1) {
              this.reciverCnt =
                " 외 " + (response.rdata.receiverBrokerAdr.length - 1) + "명";
            }
            this.senderInfo = this.convertStr(response.rdata.senderName);
            this.ctrStatusInfo = response.rdata.status;
            this.verifyMsg = response.rdata.msg;
          } else {
            this.resultCode = response.rdata.scancode;
            this.$refs.confirm
              .open("alert", "계약서 검증", response.rdata.msg)
              .then(() => {
                this.goMain();
              });
          }
        })
        .catch(e => {
          console.log(e);
        });
      this.$refs.loading.end();
    },

    // 개인정보 취급 방침
    goMain() {
      this.$router.push("/");
    }
  },
  created() {},
  mounted() {
    if (this.$route.params.contractNum) {
      this.ctrnum = this.$route.params.contractNum;
    } else {
      this.ctrnum = this.$route.query.contractNum;
    }
    console.log(this.ctrnum);
    this.scanContract();
  }
};
</script>
<style>
.inputSt_file .v-input__append-inner {
  margin-top: 11px;
}
</style>
